// Copyright (c) 2022 by Move Closer

import { Description, Identifier } from '../shared/related'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type DescriptionOfFile = File<FileType>

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export type DescriptionOfImage = ImageData

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface File<Type extends FileType> extends Description {
  id: Identifier
  mime: string
  size: string
  type: Type
  url: string
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ImageData<R extends string = string> extends File<FileType> {
  alt?: string
  author?: string
  caption?: string
  isLazy?: boolean
  srcset: ImageVariant<R>[]
  title?: string
}

export interface ImageDimensions {
  /**
   * Max displayed image height.
   * @see: https://developer.mozilla.org/en-US/docs/Web/CSS/max-height
   */
  maxHeight?: number

  /**
   * Max displayed image width.
   * @see: https://developer.mozilla.org/en-US/docs/Web/CSS/max-width
   */
  maxWidth?: number
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export interface ImageVariant<R extends string> {
  height: number|null
  ratio?: R
  url?: string
  path: string
  width: number
}

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export enum FileType {
  Attachment = 'attachment',
  Image = 'image',
  Video = 'video'
}

/**
 * @author Maciej Perzankowski <maciej.perzankowski@movecloser.pl>
 */
export interface VideoData extends File<FileType.Video> {
  fileDescription?: string
  title?: string
}
